export default function Hero() {
  const stats = [
    { value: '20000+', label: '漫画全集' },
    { value: '每日更新', label: '持续追更' },
    { value: '下拉式', label: '流畅阅读' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>
        <div className="absolute top-1/2 left-1/3 w-[400px] h-[400px] bg-secondary-200/40 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex flex-col items-start gap-5">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium">
              <i className="ri-fire-line"></i>
              <span>全网热门漫画一站畅读</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight">
              布丁漫画网
              <span className="block text-2xl md:text-3xl lg:text-4xl font-sans font-light text-foreground-600 mt-2">
                下拉式全集漫画免费阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading">
              无需翻页，一滑到底，畅享连续阅读体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
              布丁漫画网专注提供布丁漫画全集下拉式连续阅读服务，覆盖<strong>韩漫、日漫、国漫</strong>三大品类。
              无需频繁翻页，滚动即可畅读完整章节，让每一次阅读都丝滑流畅。
              每日同步更新最新全集内容，热门连载第一时间送达，布丁漫画下拉式免费看，随时随地追更不等待。
            </p>

            <div className="flex flex-wrap items-center gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-heading text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 pt-2">
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20vibrant%20digital%20illustration%20of%20a%20person%20happily%20reading%20colorful%20comics%20on%20a%20tablet%20in%20a%20cozy%20modern%20room%20with%20warm%20orange%20and%20coral%20accents%2C%20soft%20natural%20lighting%2C%20comic%20speech%20bubbles%20floating%20around%2C%20playful%20atmosphere%2C%20flat%20vector%20art%20style%20with%20clean%20lines%20and%20pastel%20background%2C%20editorial%20illustration%20quality&width=960&height=720&seq=hero-comic-2026&orientation=landscape"
                alt="布丁漫画网 - 下拉式连续阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}